import { getLocaleFromPathPrefix } from './locale-path-prefix';

const splitPathSuffix = (path: string): { pathname: string; suffix: string } => {
  const suffixIndex = path.search(/[?#]/);

  if (suffixIndex === -1) return { pathname: path, suffix: '' };

  return {
    pathname: path.slice(0, suffixIndex),
    suffix: path.slice(suffixIndex),
  };
};

export const stripLocalePathPrefix = (pathname: string): string => {
  const { pathname: pathWithoutSuffix, suffix } = splitPathSuffix(pathname);
  const [firstSegment, ...restSegments] = pathWithoutSuffix.split('/').filter(Boolean);

  if (!getLocaleFromPathPrefix(firstSegment ?? '')) return pathname;

  return `/${restSegments.join('/')}${suffix}`;
};
